/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Dropzone from 'dropzone';
import _ from 'lodash';

import { validateForm } from '@/util/ParsleyUtils';
import FileUploadModel from '@/fileupload/FileUploadModel';

import tmplDropzoneTextInputView from './DropzoneTextInputView.hbs';

import './DropzoneTextInputView.css';

const DropzoneTextInputView = View.extend({
  template: tmplDropzoneTextInputView,

  ui: {
    form: 'form',
    textInput: '.text-input'
  },

  onAttach() {
    const self = this;
    this.files = [];
    const dropzoneOptions = {
      url: '/',
      uploadMultiple: false,
      maxFiles: 1,
      autoProcessQueue: false, //stops status at "queued"
      addedfiles(files) {
        // hide text input
        self.ui.textInput.hide();

        // upload first file, remove all others
        _.each(files, (file, index) => {
          return this.accept(file, (error) => {
            !error && self.files.push(file);

            if (index === 0) {
              self.processFiles(file);
            } else {
              this.removeFile(file);
            }
          });
        });
      }
    };

    this.dropzone = new Dropzone('form.dropzone', dropzoneOptions);
  },

  async processFiles(file) {
    const preparedFile = new FileUploadModel({
      file1: file,
      tmplMethodXML: this.model.get('tmplMethodXML'),
      pathToFileId: this.model.get('pathToFileId'),
      isReadOnly: true,
      metadata: this.model.get('metadata')
    });

    preparedFile.upload();
    try {
      await preparedFile.uploadRequest;

      const formData = {
        fileName: file.upload.filename,
        attachmentId: preparedFile.get('attachmentId')
      };

      this.trigger('upload:documentUpload', formData);
    } catch (e) {
      this.trigger('error:documentUploadError', e);
      this.resetDropzone();
    }
  },

  resetDropzone() {
    this.ui.textInput.val('');
    this.ui.textInput.show();

    this.dropzone.removeAllFiles();
  },

  getFormData() {
    return { dropzoneText: this.ui.textInput.val() };
  },

  async validate() {
    await validateForm(this.ui.form);
  }
});

export default DropzoneTextInputView;
